import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("cultlyf_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => localStorage.removeItem("cultlyf_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    localStorage.setItem("cultlyf_token", res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const register = async (payload) => {
    // payload = { email, password, name, country_code, phone }
    const res = await api.post("/auth/register", payload);
    localStorage.setItem("cultlyf_token", res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  // Used by passwordless flows (OTP, magic links). Server has already validated the identity.
  const loginWithToken = (token, u) => {
    localStorage.setItem("cultlyf_token", token);
    setUser(u);
    return u;
  };

  const logout = () => {
    localStorage.removeItem("cultlyf_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, loginWithToken, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
